import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="WireGuardX" link="https://github.com/SensiPeeps/WireGuardX" bg="linear-gradient(to right, #08AEEA 0%, #2AF598 100%)" mdxType="ProjectCard">
This is an Android GUI Application for the WireGuard protocol, with kernel implementation and non-root userspace support. This version has a different theming and live network usage monitor.
    </ProjectCard>
    <ProjectCard title="Skylee" link="https://github.com/SensiPeeps/skyleebot" bg="linear-gradient(to right, #21D4FD 0%, #B721FF 100%)" mdxType="ProjectCard">
A modular Telegram Bot for group management with fun extras, written in Python3 with sqlalchemy. [DISCONTINUED]
    </ProjectCard>
    <ProjectCard title="Acutebot" link="https://github.com/SensiPeeps/WireGuardX" bg="linear-gradient(to bottom, #4158D0 0%, #C850C0 100%)" mdxType="ProjectCard">
This awesome Telegram Bot scrapes info of movies and TV shows, using TheMovieDB API, Anime and Manga data from Kitsu & music from deezer using deezloader.
    </ProjectCard>
    <ProjectCard title="KabegamiX" link="https://github.com/SensiPeeps/KabegamiX" bg="linear-gradient(to right, #0093E9 0%, #80D0C7 100%)" mdxType="ProjectCard">
An awe dropping Wallpaper app with beatiful UI, you wouldn't want to miss looking at everyday.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      